<template>
  <div>
    <div class="conference-bar">
      <div class="main-contian">
        <div class="conference-logo" @click="backHome">
          <img src="@/assets/developerConference/pc_logo.png" />
        </div>
        <ul class="hearder-bar">
          <li
            v-for="(item, index) in mainArr"
            :key="index"
            :class="[
              'hearder-item',
              {
                'hearder-active': item.name == activeName,
                'sub-container': item.name === 'subForum'
              }
            ]"
          >
            <span @click.stop="jump(item.name, item.text)">{{
              item.text
            }}</span>
          </li>
          <li @click="gotoJoinTab()" v-if="shouldShow">
            <div class="hearder-item ticketing-btn"></div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { mainArr } from "./headerConfig.json";
import { checkOnlineSignup } from "@/api/developerConference.js";
export default {
  data() {
    return {
      mainArr
    };
  },

  components: {},
  mounted() {},
  computed: {
    ...mapGetters(["timeOver"]),
    activeName() {
      return this.$route.path.split("/")[2];
    },
    shouldShow() {
      // 超时和首页判断
      if (this.timeOver) {
        return false;
      } else {
        return !["conferenceIndex"].includes(this.activeName);
      }
    }
  },

  methods: {
    // 通过设计一个默认参数来方便函数编写传参
    jump(name, params = "") {
      // 对分论坛参数进行处理,因为修改路由太麻烦使用会话缓存保存传递的变量
      // 无法通过路由跳转，取消
      // if (params !== "") {
      //   sessionStorage.setItem("subForum", { subForum: params });
      // }
      this.$router.push({ path: "/developerConference/" + name });
      // 导航栏点击埋点
      this.gioTrackEvent("LDC_topNavBarClick", {
        navBarName_var: params,
        deviceType_var: "Web",
        hsUserId_var: this.hsid || "-"
      });
    },
    // 去报名
    gotoJoinTab() {
      checkOnlineSignup().then(res => {
        // 未登录，会提示登录
        if (res === undefined) return;

        // 没报名
        if (res === null || res.data === null) {
          this.$router.push({ path: "/developerConference/ticketing" });
          // 从导航栏点击报名的次数埋点
          let hsid = this.$store.getters.hsid||'';
          this.gioTrackEvent("LDC_loginUserApplyClick", {
            pageName_var: this.$route.name,
            hsUserId_var: hsid,
            deviceType_var: "Web"
          });
        }
        // 已报名
        else {
          this.$hMessage.info("您已成功报名，无须重复报名。");
        }
      });
    },
    getActive() {
      this.$emit("pf");
    },
    backHome() {
      this.$router.push({ path: "conferenceIndex" });
    }
  }
};
</script>
<style lang="scss" scoped>
.conference-bar {
  height: 78px;
  min-width: 1200px;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  .main-contian {
    height: 100%;
    min-width: 1200px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .conference-logo {
      flex-basis: 406px;
      flex-shrink: 0;
      cursor: pointer;
      width: 406.01px;
      height: 78px;
      img {
        margin: auto 20px;
        width: 100%;
        height: 100%;
      }
    }
    .hearder-bar {
      flex-shrink: 1;
      display: flex;
      // 修复滚动条对定位的影响
      margin-right: calc(100% - 100vw);
      .hearder-item {
        margin-right: 54px;
        height: 78px;
        line-height: 78px;
        font-family: MicrosoftYaHei;
        font-size: 16px;
        position: relative;
        // background-image: linear-gradient(270deg, #4945ff 0%, #3ffffe 100%);
        // 下划线
        &::after {
          content: "";
          position: absolute;
          width: 100%;
          transform: scaleX(0);
          height: 4px;
          bottom: 0;
          left: 0;
          background-image: linear-gradient(270deg, #4945ff 0%, #3ffffe 100%);
          transform-origin: bottom right;
          transition: transform 0.25s ease-out;
        }
        &:hover::after {
          transform: scaleX(1);
          transform-origin: bottom left;
        }
        &:hover {
          font-weight: 700;
        }
        span {
          cursor: pointer;
        }
      }
      // 分论坛or有下拉菜单的
      .sub-container {
        position: relative;
        width: 80px;
        .sub-nav {
          text-align: center;
          width: 100%;
          position: absolute;
          overflow: hidden;
          font-size: 14px;
          height: 0;
          transition: all 0.5s ease-out;
          li,
          span {
            cursor: pointer;
            margin-bottom: 10px;
            line-height: 20px;
          }
          span:hover {
            background-color: #ccc;
            opacity: 0.9;
            transition: all 0.1s ease-out;
          }
        }
        &:hover .sub-nav {
          height: 220px;
          background-color: #fff;
          opacity: 0.7;
        }
      }
      @media (max-width: 1366px) {
        .hearder-item {
          margin-right: 40px;
        }
      }
      .ticketing-btn {
        width: 127px;
        height: 43px;
        background: url("../../../../assets/developerConference/joinNow.png")
          no-repeat;
        background-size: cover;
        margin-top: 20px;
        box-sizing: border-box;
        cursor: pointer;
      }
      .hearder-active {
        font-weight: 700;
        position: relative;
        &::after {
          display: inline-block;
          content: "";
          height: 4px;
          transform: scaleX(1);
          transform-origin: bottom left;
          width: 100%;
          background-image: linear-gradient(270deg, #4945ff 0%, #3ffffe 100%);
          position: absolute;
          bottom: 0;
          left: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/frontViews/developerConference/components/conferenceHeader.vue